import { render } from "./store_list.vue?vue&type=template&id=5287996a"
import script from "./store_list.vue?vue&type=script&lang=js"
export * from "./store_list.vue?vue&type=script&lang=js"

import "./store_list.vue?vue&type=style&index=0&id=5287996a&lang=css"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__